import type { Action } from 'redux';
import CustomPartnerService from '../../../../../../shared/CustomPartner.service';
import { linkMacrosAreEqual } from '../../../../main/screens/LinkCreator/utils';
import dash_api from '../../../../main/support/dash_api';
import type { AdPartner } from '../../../../main/types/adPartnerTypes';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const FetchAvailableAdPartners = new ReduxAsyncAction<
  'FETCH_AVAILABLE_AD_PARTNERS',
  void,
  { availableAdPartners: AdPartner[]; osTypeEnabledLookup: Record<string, boolean> }
>('FETCH_AVAILABLE_AD_PARTNERS');

FetchAvailableAdPartners.registerRequest(
  async (): Promise<{ availableAdPartners: AdPartner[]; osTypeEnabledLookup: Record<string, boolean> }> => {
    const appAdPartners: Record<string, AdPartner> = await dash_api.get(`/v1/ad-networks/app`).then(({ data }) => data);
    const globalAdPartners: AdPartner[] = await dash_api.get('/v1/ad-networks/global').then(({ data }) => data);

    const osTypeEnabledLookup: Record<string, boolean> = {};
    const availableAdPartners: AdPartner[] = [];

    globalAdPartners.forEach((globalAdPartner) => {
      if (Object.keys(appAdPartners).includes(globalAdPartner.machine_name)) {
        const adPartner = appAdPartners[globalAdPartner.machine_name];

        if (adPartner) {
          availableAdPartners.push({
            ...adPartner,
            company_name: globalAdPartner.company_name,
          });

          const linkOnlyParameters = globalAdPartner.link_only_parameters;
          if (!linkOnlyParameters) {
            osTypeEnabledLookup[globalAdPartner.machine_name] = false;
          } else if (
            !linkMacrosAreEqual(linkOnlyParameters, 'CLICK_AAID', 'CLICK_IDFA') &&
            !linkMacrosAreEqual(linkOnlyParameters, 'CLICK_AAID_SHA1', 'CLICK_IDFA_SHA1') &&
            !linkMacrosAreEqual(linkOnlyParameters, 'CLICK_AAID_MD5', 'CLICK_IDFA_MD5')
          ) {
            osTypeEnabledLookup[globalAdPartner.machine_name] = false;
          } else {
            osTypeEnabledLookup[globalAdPartner.machine_name] = true;
          }
        }
      }
    });

    for (const key in appAdPartners) {
      if (CustomPartnerService.isCustomPartner({ machine_name: key })) {
        availableAdPartners.push(appAdPartners[key]);
        osTypeEnabledLookup[appAdPartners[key].machine_name] = false;
      }
    }

    return { availableAdPartners, osTypeEnabledLookup };
  }
);

export const FETCH_AVAILABLE_AD_PARTNERS = FetchAvailableAdPartners.actionNamespaceConstants;
export const fetchAvailableAdPartners = FetchAvailableAdPartners.request;

export type FetchAvailableAdPartnersResponseAction = Action<typeof FETCH_AVAILABLE_AD_PARTNERS.response> & {
  data: { availableAdPartners: AdPartner[]; osTypeEnabledLookup: Record<string, boolean> };
};
